import type { AsyncFieldConfiguration } from '@atlassian/proforma-form-renderer/async-fields';

import type { JiraFieldData } from '../../../../../../controllers/request-create-context-provider/types';
import type { useUsers } from '../../users';
import type { useUsersConfigured } from '../../users-configured';

export const resolveUserConfig = (
	jiraFieldKey: string | undefined,
	jiraFieldData: JiraFieldData,
	usersConfiguredFn: ReturnType<typeof useUsersConfigured>,
	usersFn: ReturnType<typeof useUsers>,
): AsyncFieldConfiguration => {
	const jiraFieldConfigId =
		jiraFieldKey === undefined ? undefined : jiraFieldData.get(jiraFieldKey)?.fieldConfigId;
	if (jiraFieldKey && jiraFieldConfigId) {
		return usersConfiguredFn(jiraFieldKey, jiraFieldConfigId);
	}
	return usersFn();
};
